<h1 style="margin-top: 15px" class="title-modal-add-user">
  <mat-slide-toggle [checked]="signupForm.get('secondFunction').value" (change)="onChangeFunction($event)">F2</mat-slide-toggle>
  <strong>Import File</strong>
  <mat-icon (click)="onClose(false)">close</mat-icon>
</h1>
<mat-divider class="divider"></mat-divider>
<form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
  <div mat-dialog-content>
    <div style="display: flex; flex-direction: column" class="part1-formulaire">
      <mat-form-field fxFill appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput id="name" formControlName="name" type="text" placeholder="Enter the name of the File" />
      </mat-form-field>
      <mat-form-field fxFill appearance="fill">
        <mat-label>Target table</mat-label>
        <input matInput id="targetName" formControlName="targetName" type="text" placeholder="Enter the name of Table" />
      </mat-form-field>
    </div>

    <div class="part2-Formulaire">
      <div class="part2-formulaire-fct">
        <mat-form-field appearance="fill">
          <mat-label>Connection DB</mat-label>
          <mat-select placeholder="Column type" formControlName="connectionDBId">
            @for (item of connectionDB; track item.id) {
            <mat-option [value]="item.id">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="part3-Formulaire">
        <mat-form-field class="separator-style" appearance="fill">
          <mat-label>Separator</mat-label>
          <input matInput id="delimiter" formControlName="delimiter" type="text" placeholder="Enter the delimiter" />
        </mat-form-field>
        <div class="part3-Formulaire-controller">
          <mat-checkbox (change)="checkboxChanged($event)" formControlName="header">Header</mat-checkbox>
          <mat-checkbox (change)="checkboxChanged($event)" formControlName="append">Append</mat-checkbox>
          <mat-checkbox (change)="checkboxChanged($event)" formControlName="autoIncrement">A_I</mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="nullable-container">
    <span class="nullable-checkbox">Null</span>
  </div>
  <div class="columns-container" formArrayName="columnCsvList" micScrollBar>
    @for (column of controls; track $index; let i = $index) {
    <div>
      <div [formGroupName]="i" class="column-container">
        <mat-form-field appearance="fill">
          <mat-label>Column</mat-label>
          <input matInput type="text" formControlName="name" [placeholder]="'Column ' + i" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Controller</mat-label>
          <mat-select placeholder="Column type" formControlName="controllerId">
            @for (item of controllers; track item.id) {
            <mat-option [value]="item.id">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-checkbox
          formControlName="nullable"
          (change)="checkboxChanged($event)"
          matTooltip="isNullabe"
          matTooltipPosition="above"
        ></mat-checkbox>
        <mic-icon (click)="onDeleteColumn(i)" style="cursor: pointer" icon="delete"></mic-icon>
      </div>
    </div>
    }
  </div>
  <div class="icon-body">
    <div class="icon-container">
      <mic-icon (click)="onAddColumn()" style="cursor: pointer" icon="add"></mic-icon>
    </div>
  </div>
  <mat-divider class="divider"></mat-divider>

  <div mat-dialog-actions class="btn-container">
    @if (data) {
    <button type="submit" mat-raised-button color="warn" [disabled]="!signupForm.valid">Update</button>
    } @else {
    <button type="submit" mat-raised-button color="primary" [disabled]="!signupForm.valid">Add a function</button>
    }
  </div>
</form>
